const searchConfig = {
  termsToExclude: [ 'a', 'an', 'and', 'for', 'of', 'the', 'to', 'with' ],
};

export default searchConfig;
